import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { constants } from "@/modules/calculations/consts";
import { useMatchingBonusValueStore } from "@/modules/matching-bonus/store/value";
import { useTranslation } from "react-i18next";

const WillReceive = () => {
  const { t } = useTranslation();
  const { airdrop, matchingBonus, matchingBonusBASE } = useUserStore();

  const { currentToken, net } = useMatchingBonusValueStore();

  const token = net === "base" ? "BTN" : currentToken === "ton" ? "TON" : "BTN";

  const amount =
    net === "base"
      ? matchingBonusBASE.tokenAmount
      : currentToken === "ton"
      ? matchingBonus.tonAmount
      : matchingBonus.tokenAmount;

  return (
    <div className="flex w-full flex-col gap-4">
      <p className="p-4 pb-2 text-[1rem] leading-[1.3125rem] font-semibold text-text tracking-tighter">
        {t("withdraw-page.will_receive")}
      </p>

      <div className="w-full flex items-center justify-between gap-4 px-4 py-0.5 bg-bg rounded-[0.75rem]">
        <div className="flex items-center gap-4">
          <img src="/images/TON.png" alt="" className="w-7 h-7" />

          <div className="flex flex-col py-3 gap-0.5">
            <p className="text-[1.0625rem] leading-[1.375rem] font-medium text-text">
              {t("withdraw-page.token_amount", { token: token })}
            </p>
            <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
              {t("withdraw-page.your_wallet")}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-end py-3 gap-0.5">
          <p className="text-[1.0625rem] leading-[1.375rem] text-text">
            {formatNumber(amount)} {token}
          </p>
          <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
            ≈ $
            {formatNumber(
              net === "ton"
                ? matchingBonus.usdAmount
                : matchingBonusBASE.usdAmount
            )}
          </p>
        </div>
      </div>

      {currentToken === "ton" && net === "ton" && (
        <div className="flex w-full flex-col">
          <div className="flex items-center justify-between bg-bg rounded-[0.75rem] px-4 py-0.5">
            <p className="text-[1.0625rem] leading-[1.375rem] text-text py-3">
              {t("airdrop-page.transaction_fees")}
            </p>

            <p className="text-[1.0625rem] leading-[1.375rem] text-text">
              {formatNumber(airdrop.fee || 0, {
                precision: constants.TON_DECIMALS,
              })}{" "}
              TON
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WillReceive;
